import { Injectable } from '@angular/core';
import { isNil, reject } from 'lodash-es';

import { ApplicationAdapter } from 'application/application.adapter';
import { Article } from 'article/article';
import { ArticleI18n } from 'article/article-i18n';
import { ArticleOutput } from 'article/model/article.output';
import { ArticleConverterPort } from 'article/port/article-converter.port';

@Injectable()
export class ArticleConverterAdapter
	extends ApplicationAdapter
	implements ArticleConverterPort
{
	public articleAsEntity(output: ArticleOutput): Article {
		if (!output) {
			return null;
		}

		return new Article(
			output.id,
			output.updateTimestamp,
			(output.localizations || []).map(
				(loc) =>
					new ArticleI18n(
						loc.title,
						loc.locale,
						loc.content,
						loc.videoId,
						loc.pictureUrl
					)
			)
		);
	}

	public articlesAsEntities(outputs: ArticleOutput[]): Article[] {
		return reject(outputs, isNil).map((output) => this.articleAsEntity(output));
	}
}
